import React from "react";
import isPropValid from "@emotion/is-prop-valid";
import { StyleSheetManager } from "styled-components";

// styled-components v6 no longer filters props or adds vendor prefixes by
// default. Restore the v5 behaviour so the rendered DOM and CSS stay as before.
function shouldForwardProp(propName, target) {
  return typeof target === "string" ? isPropValid(propName) : true;
}

export function wrapRootElement({ element }) {
  return (
    <StyleSheetManager enableVendorPrefixes shouldForwardProp={shouldForwardProp}>
      {element}
    </StyleSheetManager>
  );
}
